var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyCircle = function SvgMoneyCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.7c-.8.1-1.3.4-1.3 1 0 .5.3.9 1.3 1.1V6.7zM12.1 12.1c0-.6-.3-.9-1.4-1.2v2.4c.9-.1 1.4-.5 1.4-1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 19c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9zm1-9.8c2.1.5 3 1.2 3 2.7 0 1.8-1.4 2.8-3.4 2.9V16H9.5v-1.1C7.3 14.7 6 13.6 6 11.7h1.9c0 .9.5 1.4 1.5 1.6v-2.6h-.2c-2.1-.5-3-1.2-3-2.7 0-1.5 1-2.6 3.2-2.8V4h1.2v1.1c2 .2 3.1 1.3 3.1 3h-1.9c0-.7-.4-1.2-1.2-1.4v2.4l.4.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMoneyCircle;